import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';
import useSendFeatureBranchToDataDog from '~/hooks/common/telemetry/useSendFeatureBranchToDataDog';

export default function useSetDataDogContext(dealershipId: string) {
  useSendFeatureBranchToDataDog();

  useEffect(() => {
    datadogRum.setGlobalContextProperty('dealershipId', dealershipId);
  }, [dealershipId]);
}
